import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import configureStore from "./configureStore";
import "./index.css";
import App from "./App";
import swDev from "./swDev";
import { appOnlineOfflineMode } from "./actions/commonActions";
import setAxiosHeader, { setChargingStationID } from "./utils/setAxiosHeader";

// import * as serviceWorker from "./serviceWorker";

export const store = configureStore();

if (localStorage.ev_charging_site_id) {
  setChargingStationID(localStorage.ev_charging_site_id);
}
if (localStorage.driverToken) {
  setAxiosHeader(localStorage.driverToken);
} else {
  if (!["/", "/signup"].includes(window.location.pathname)) {
    window.location.href = "/";
  }
}

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

//custom service worker
swDev();

//fire when browser is online
window.addEventListener("online", (event) => {
  appOnlineOfflineMode(store.dispatch, true);
  console.log("You are now connected to the network .");
  //reload browser
  window.location = window.location;
});

//fire when browser is offline
window.addEventListener("offline", function (event) {
  appOnlineOfflineMode(store.dispatch, false);
  console.log("You've lost connection in appJS.");
});
